<template>
  <vuestic-modal ref="modal">
    <div slot="title">Cambiar Proveedor</div>
    <select-form :options="proveedores" label="Seleccione Proveedor" @input="changeProveedor"/>
    <br>
    <div class="row">
      <div class="col-4">
        <input-comp label="Precio compra" :value="producto.costo_pactado" placeholder="Costo pactado" @input="changeCostoPactado"/>
      </div>
    </div>
    <button class="btn btn-info btn-sm" @click="cambiarProveedor">Guardar</button>
  </vuestic-modal>
</template>

<script>
import VuesticModal from "vuestic-components/vuestic-modal/VuesticModal";
import SelectForm from "components/Finanzas/Components/select-form";
import {mapGetters} from "vuex";
import InputComp from "components/Componentes_Globales/Input/inputComp";
export default {
  name: "cambioProveedorModal",
  components: {InputComp, SelectForm, VuesticModal},
  props: {
    producto: {required: true}
  },
  created() {
    this.costo_pactado = this.producto.costo_pactado
    this.$store.dispatch('proveedores/getProveedores')
  },
  data(){
    return {
      costo_pactado: this.producto.costo_pactado,
      proveedor: null
    }
  },
  methods: {
    changeProveedor({value}) {
      this.proveedor = value
    },
    changeCostoPactado(value) {
      this.costo_pactado = parseInt(value, 10)
    },
    openModal() {
      this.$refs.modal.open()
    },
    cambiarProveedor() {
      this.$store.dispatch('proveedores/updateProveedor', {
        proveedor: this.proveedor,
        costo: this.costo_pactado || this.producto.costo_pactado,
        producto_id: this.producto.producto_id
      })
    }
  },
  computed: {
    ...mapGetters({
      proveedores: "proveedores/listProveedores",
      fetching: "proveedores/fetching",
      saved: "proveedores/saved"
    })
  },
  watch: {
    saved: function (newValue, oldValue) {
      console.log('saved', newValue)
      if (newValue) {
        this.$refs.modal.close()
        this.$emit('updated')
      }
    }
  }
}
</script>

<style scoped>

</style>
